import { LOCAL_STORAGE_KEYS } from '../../../constants/system/LOCAL_STORAGE_KEYS';

// the same millisecond would be silently dropped. Append randomness to guarantee uniqueness.
// conected with useTabSynchronization hook
export const reloadOtherTabs = () => {
  const signal = `${Date.now()}-${Math.random()}`;
  localStorage.setItem(LOCAL_STORAGE_KEYS.RELOAD_OTHER_TABS, signal);
};
